// src/components/shipment/components/ShipmentProgress.tsx

import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
  Badge
} from '@mui/material';
import {
  CheckCircle,
  PauseCircle,
  RadioButtonUnchecked,
  QrCodeScanner
} from '@mui/icons-material';

interface ShipmentProgressProps {
  newBoxes: number;
  pausedBoxes: number;
  completedBoxes: number;
  totalScannedItems: number;
}

const ShipmentProgress: React.FC<ShipmentProgressProps> = ({
  newBoxes,
  pausedBoxes,
  completedBoxes,
  totalScannedItems
}) => {
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ py: 2 }}>
        <Grid container spacing={3} textAlign="center">
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center">
              <Badge badgeContent={newBoxes} color="info" max={999}>
                <RadioButtonUnchecked color="info" />
              </Badge>
              <Typography
                variant="h6"
                color="info.main"
                fontWeight="bold"
              >
                {newBoxes}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                New Boxes
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center">
              <Badge badgeContent={pausedBoxes} color="warning" max={999}>
                <PauseCircle color="warning" />
              </Badge>
              <Typography
                variant="h6"
                color="warning.main"
                fontWeight="bold"
              >
                {pausedBoxes}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Paused
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center">
              <Badge
                badgeContent={completedBoxes}
                color="success"
                max={999}
              >
                <CheckCircle color="success" />
              </Badge>
              <Typography
                variant="h6"
                color="success.main"
                fontWeight="bold"
              >
                {completedBoxes}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Completed
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Stack alignItems="center">
              <Badge
                badgeContent={totalScannedItems}
                color="primary"
                max={999}
              >
                <QrCodeScanner color="primary" />
              </Badge>
              <Typography
                variant="h6"
                color="primary.main"
                fontWeight="bold"
              >
                {totalScannedItems}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Items Scanned
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ShipmentProgress;